<template>
  <div class="page-container">
    <div class="query-title">公关团购产品</div>

    <div class="content table-query">
      <QueryParams
        ref="QueryParams"
        :loading="loading"
        :search-field="searchField"
        @search="queryData"
      />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="add" tip="新增" @click="openDialog()" />
            <table-button name="apply" tip="修改" @click="handleBatchModify" />
            <table-button name="apply" tip="启用" @click="handleBatchStatus('X')" />
            <table-button name="cancle" tip="禁用" @click="handleBatchStatus('')" />
            <table-button name="export" tip="导出" @click="handleExport" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="420"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{ name: 'NotData' }"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ isCurrent: true }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            @filter-change="filterChangeEvt"
          >
            <template #parameter3="{ row }">
              <span class="cell-text">{{ row.parameter3 || '--' }}</span>
            </template>
            <template #product_name="{ row }">
              <span class="cell-text">{{ row.product_name || '--' }}</span>
            </template>
            <template #active="{ row }">
              <el-tag size="mini" :type="row.active === 'X' ? 'success' : 'info'">
                {{ row.active === 'X' ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter
      ref="CustomFilter"
      :current-filter-field="currentFilterField"
      @confirm="customeFilter"
    />

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="520px" @closed="resetDialog">
      <el-form
        ref="dialogForm"
        :model="formModel"
        :rules="dialogRules"
        label-width="130px"
        size="mini"
      >
        <el-form-item v-if="isEdit" label="序号" prop="parameter2">
          <el-input v-model.trim="formModel.parameter2" placeholder="请输入序号" disabled />
        </el-form-item>
        <el-form-item label="产品编码" prop="parameter3">
          <el-input
            v-model.trim="formModel.parameter3"
            placeholder="请选择产品"
            readonly
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              :disabled="isEdit"
              @click="openProductDialog"
            />
          </el-input>
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input v-model="formModel.product_name" placeholder="请输入产品名称" disabled />
        </el-form-item>
        <el-form-item label="最小订单件数" prop="parameter4">
          <el-input v-model.trim="formModel.parameter4" placeholder="请输入最小订单件数" />
        </el-form-item>
        <el-form-item label="最大订单件数" prop="parameter5">
          <el-input v-model.trim="formModel.parameter5" placeholder="请输入最大订单件数" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch
            v-model="formModel.active"
            active-value="X"
            inactive-value=""
            active-text="启用"
            inactive-text="禁用"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        <el-button size="mini" type="primary" :loading="submitLoading" @click="submitDialog">保存</el-button>
      </template>
    </el-dialog>

    <el-dialog
      title="批量修改"
      :visible.sync="batchEditVisible"
      width="70%"
      @closed="resetBatchEdit"
    >
      <GroupPurchaseEdit ref="BatchEdit" :edit-rows="batchEditList" v-if="batchEditVisible" />
      <template #footer>
        <el-button size="mini" @click="batchEditVisible = false">取消</el-button>
        <el-button size="mini" type="primary" :loading="batchEditSubmitting" @click="submitBatchEdit">
          保存
        </el-button>
      </template>
    </el-dialog>

    <el-dialog
      title="选择产品"
      :visible.sync="productDialogVisible"
      width="80%"
      @close="closeProductDialog"
    >
      <ProductSelect v-if="productDialogVisible" ref="productSelector" />
      <template #footer>
        <el-button size="mini" @click="closeProductDialog">取消</el-button>
        <el-button size="mini" type="primary" @click="confirmProductSelect">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'
import { apiGroupPurchaseProduct } from '@/api/sap/client-sap'
import pageConfig, { pageSearch } from './config/groupPurchaseProduct'
import tableMixins from '@/utils/tableMixins'
import ProductSelect from '@/components/dialog/ProductSelect.vue'
import GroupPurchaseEdit from './components/GroupPurchaseEdit.vue'
import { frontExport } from '@/utils/frontExport'

const getDefaultForm = () => ({
  parameter1: '',
  parameter2: '',
  parameter3: '',
  product_name: '',
  parameter4: '',
  parameter5: '',
  active: 'X'
})

export default {
  name: 'GroupPurchaseProduct',
  components: { ProductSelect, GroupPurchaseEdit },
  mixins: [tableMixins],
  data() {
    const integerRule = { pattern: /^\d+$/, message: '请输入非负整数', trigger: 'blur' }
    const validateMax = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入最大订单件数'))
        return
      }
      if (!/^\d+$/.test(value)) {
        callback(new Error('请输入非负整数'))
        return
      }
      if (this.formModel.parameter4 && Number(value) < Number(this.formModel.parameter4)) {
        callback(new Error('最大订单件数需大于等于最小订单件数'))
        return
      }
      callback()
    }
    const seqValidator = (rule, value, callback) => {
      if (!this.isEdit) {
        callback()
        return
      }
      if (!value) {
        callback(new Error('请输入序号'))
        return
      }
      if (!/^\d+$/.test(value)) {
        callback(new Error('请输入非负整数'))
        return
      }
      callback()
    }
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        data: [],
        columns: []
      },
      pageSearch,
      searchField: pageSearch,
      dialogVisible: false,
      submitLoading: false,
      isEdit: false,
      formModel: getDefaultForm(),
      productDialogVisible: false,
      batchEditVisible: false,
      batchEditList: [],
      batchEditSubmitting: false,
      dialogRules: {
        parameter2: [{ validator: seqValidator, trigger: 'blur' }],
        parameter3: [
          { required: true, message: '请输入产品编码', trigger: 'blur' }
        ],
        parameter4: [
          { required: true, message: '请输入最小订单件数', trigger: 'blur' },
          integerRule
        ],
        parameter5: [
          { validator: validateMax, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['role']),
    dialogTitle() {
      return this.isEdit ? '编辑公关团购产品' : '新增公关团购产品'
    }
  },
  created() {
    this.initPage(pageConfig)
    this.gridOptions.columns.unshift({ type: 'checkbox', field: 'checkbox', width: 40, fixed: 'left' })
    this.decorateColumns()
    this.queryData()
  },
  methods: {
    decorateColumns() {
      const codeCol = this.gridOptions.columns.find(col => col.field === 'parameter3')
      if (codeCol) {
        codeCol.slots = { default: 'parameter3' }
      }
      const nameCol = this.gridOptions.columns.find(col => col.field === 'product_name')
      if (nameCol) {
        nameCol.slots = { default: 'product_name' }
      }
      const statusCol = this.gridOptions.columns.find(col => col.field === 'active')
      if (statusCol) {
        statusCol.slots = { default: 'active' }
      }
      const seqCol = this.gridOptions.columns.find(col => col.field === 'parameter2')
      if (seqCol) {
        seqCol.visible = false
      }
    },
    buildQueryParams() {
      const params = {}
      // 使用数组条件的字段（产品编号、产品名称）
      const arrayConditionFields = ['product_id', 'product_name']
      
      Object.keys(this.allConditions || {}).forEach(field => {
        const condition = this.allConditions[field]
        if (Array.isArray(condition) && condition.length) {
          const conditionItem = condition[0]
          const low = conditionItem.low || conditionItem.LOW
          const option = conditionItem.option || conditionItem.OPTION
          const sign = conditionItem.sign || conditionItem.SIGN || 'I'
          
          // 对于产品编号和产品名称，使用数组条件格式
          if (arrayConditionFields.includes(field)) {
            if (low !== undefined && low !== '') {
              // 根据选项类型处理：CP 需要加 *，EQ 不需要
              let lowValue = low
              if (option === 'CP' || option === 'CP-S') {
                // 如果已经是模糊查询格式，直接使用；否则添加 * 号
                if (!lowValue.startsWith('*')) {
                  lowValue = `*${lowValue}*`
                }
              }
              // 使用后端期望的大写格式
              params[field] = [{
                SIGN: sign,
                OPTION: option || 'CP',
                LOW: lowValue,
                HIGH: ''
              }]
            }
          } else {
            // 其他字段保持原有逻辑（转换为简单值）
            if (low !== undefined && low !== '') {
              params[field] = low
            }
          }
        }
      })
      return params
    },
    async queryData(page = 1, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      this.loading = true
      try {
        const params = {
          user_bp: this.role.USER_BP,
          mode: 'SELECT',
          ...this.buildQueryParams()
        }
        const response = await apiGroupPurchaseProduct(params)
        const { msgtype, message, data, field } = response
        if (msgtype === 'S') {
          const list = data || []
          this.gridOptions.data = list
          this.pagination.totalCount = list.length
        } else {
          this.gridOptions.data = []
          message && this.$message.error(message)
          this.pagination.totalCount = 0
        }
        this.updateCount()
        // 处理过滤选项数据，参考 clientQuery.vue 的写法
        if (field && field.length > 0) {
          this.allOptions = this.filterAllOptions(field)
          // 使用 $nextTick 确保表格列已经加载后再设置过滤器
          this.$nextTick(() => {
            this.setFilter()
          })
        } else {
          this.setFilter()
        }
      } catch (error) {
        this.$message.error('查询失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    },
    openDialog(row) {
      if (row) {
        this.isEdit = true
        this.formModel = {
          parameter1: row.parameter1 || '',
          parameter2: row.parameter2 || '',
          parameter3: row.parameter3 || '',
          product_name: row.product_name || '',
          parameter4: row.parameter4 || '',
          parameter5: row.parameter5 || '',
          active: row.active || ''
        }
      } else {
        this.isEdit = false
        const defaultForm = getDefaultForm()
        defaultForm.parameter1 = ''
        defaultForm.parameter2 = ''
        this.formModel = defaultForm
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.dialogForm) {
          this.$refs.dialogForm.clearValidate()
        }
      })
    },
    resetDialog() {
      this.formModel = getDefaultForm()
      this.submitLoading = false
    },
    openProductDialog() {
      if (this.isEdit) return
      this.productDialogVisible = true
      this.$nextTick(() => {
        this.$refs.productSelector && this.$refs.productSelector.reset && this.$refs.productSelector.reset()
      })
    },
    closeProductDialog() {
      this.productDialogVisible = false
    },
    async confirmProductSelect() {
      if (!this.$refs.productSelector) {
        this.productDialogVisible = false
        return
      }
      const selected = await this.$refs.productSelector.submitForm()
      if (selected) {
        this.formModel.parameter3 = selected.PRODUCT_ID || selected.productCode || ''
        this.formModel.product_name = selected.SHORT_TEXT || selected.description || selected.productShortName || ''
      }
      this.productDialogVisible = false
    },
    async submitDialog() {
      this.$refs.dialogForm.validate(async valid => {
        if (!valid) return
        this.submitLoading = true
        try {
          const formData = {
            parameter1: this.formModel.parameter1 || '',
            parameter2: `${this.formModel.parameter2 || ''}`,
            parameter3: this.formModel.parameter3 || '',
            parameter4: `${this.formModel.parameter4 || ''}`,
            parameter5: `${this.formModel.parameter5 || ''}`,
            active: this.formModel.active || ''
          }
          if (!this.isEdit) {
            formData.parameter2 = ''
          }

          const payload = {
            user_bp: this.role.USER_BP,
            mode: this.isEdit ? 'UPDATE' : 'INSERT',
            data: [
              formData
            ]
          }
          const { msgtype, message } = await apiGroupPurchaseProduct(payload)
          if (msgtype === 'S') {
            this.$message.success(message || '操作成功')
            this.dialogVisible = false
            this.queryData()
          } else {
            this.$message.error(message || '操作失败')
          }
        } catch (error) {
          this.$message.error('操作失败，请稍后重试')
        } finally {
          this.submitLoading = false
        }
      })
    },
    getCheckedRows() {
      const rows = this.$refs.xTable?.getCheckboxRecords?.() || []
      if (!rows.length) {
        this.$message.warning('请选择数据')
        return null
      }
      return rows
    },
    handleBatchModify() {
      const rows = this.getCheckedRows()
      if (!rows) return
      this.batchEditList = cloneDeep(rows).map(row => ({
        ...row,
        parameter4: row.parameter4 || '',
        parameter5: row.parameter5 || ''
      }))
      this.batchEditVisible = true
    },
    async handleBatchStatus(status) {
      const rows = this.getCheckedRows()
      if (!rows) return
      rows.forEach(row => {
        row.active = status
      })
      this.saveRows(rows, 'UPDATE')
    },
    async saveRows(rows, mode = 'UPDATE') {
      if (!rows.length) return
      try {
        this.loading = true
        const payload = {
          user_bp: this.role.USER_BP,
          mode,
          data: rows.map(row => ({
            parameter1: row.parameter1 || '',
            parameter2: `${row.parameter2 || ''}`,
            parameter3: row.parameter3 || '',
            parameter4: `${row.parameter4 || ''}`,
            parameter5: `${row.parameter5 || ''}`,
            active: row.active || ''
          }))
        }
        const { msgtype, message } = await apiGroupPurchaseProduct(payload)
        if (msgtype === 'S') {
          this.$message.success(message || '操作成功')
          this.queryData()
        } else {
          this.$message.error(message || '操作失败')
        }
      } catch (error) {
        this.$message.error('操作失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    async submitBatchEdit() {
      const validRows = this.$refs.BatchEdit?.validRows?.()
      if (!validRows) return
      this.batchEditSubmitting = true
      try {
        await this.saveRows(validRows, 'UPDATE')
        this.batchEditVisible = false
        this.batchEditList = []
        this.$refs.BatchEdit?.reset?.()
      } finally {
        this.batchEditSubmitting = false
      }
    },
    resetBatchEdit() {
      this.batchEditList = []
      this.batchEditSubmitting = false
      this.$refs.BatchEdit?.reset?.()
    },
    handleExport() {
      const data = this.gridOptions.data || []
      if (!data.length) {
        this.$message.warning('暂无数据可导出')
        return
      }
      const columns = this.gridOptions.columns.filter(col => !col.type && col.visible !== false)
      frontExport(columns, data, '公关团购产品')
    }
  }
}
</script>

<style lang="scss" scoped>
.table-container {
  margin-top: 16px;
}

.cell-text {
  color: #333;
}
</style>




// WEBPACK FOOTER //
// src/views/product-manage/groupPurchaseProduct.vue